import { configureStore } from "@reduxjs/toolkit";

import loaderReducer from "./loaderSlice";
import verificationDeclineSlice from "../../features/emailVerification/slices/verificationDeclineSlice";
import verificationMethodSelectionSlice from "../../features/emailVerification/slices/verificationMethodSelectionSlice";
import verifyUserSlice from "../../features/emailVerification/slices/verifyUserSlice";
import verificationActionSlice from "../../features/emailVerification/slices/verificationActionSlice";

export const store = configureStore({
	reducer: {
		loader: loaderReducer,
		caseInfo: verificationMethodSelectionSlice,
		verificationData: verifyUserSlice,
		verificationDecline: verificationDeclineSlice,
		verificationAction: verificationActionSlice
	}
});
